import _ from 'lodash';

function DPClaimExtension(claim) {
    if (claim && claim.lobs && claim.lobs.dwellingProperty) {
        _.extend(this, claim.lobs.dwellingProperty);
    }
}

export default DPClaimExtension;
